import { HEAD_PLAYER_TITLE } from './translations'
import {
    PlayerColumnTooltipContent,
    PlayerStatusColumnTooltipContent,
    RoleColumnTooltipContent,
} from '../ClanManagement/tooltips'

export const FirstCommonHeaders = [
    {
        type: 'role',
        isSortable: true,
        icon: 'role',
        key: 'head-role',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: RoleColumnTooltipContent.tip,
    },
    {
        type: 'basis',
        isSortable: true,
        text: HEAD_PLAYER_TITLE,
        key: 'head-player',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: PlayerColumnTooltipContent.tip,
    },
]

export const LastCommonHeaders = [
    {
        isSortable: true,
        icon: 'status',
        key: 'head-player-status-in-game',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: PlayerStatusColumnTooltipContent.tip,
    },
]



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/CommonHeaders.settings.js